// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-configuration {
  --mc-ink: #172b4d;
  --mc-muted: #64748b;
  --mc-line: #e4eaf2;
  color: var(--mc-ink);
  padding: 26px 24px !important;
}
.menu-configuration .mc-icon {
  display: inline-block;
  flex: 0 0 auto;
  vertical-align: middle;
}
.menu-configuration .mc-page-heading {
  margin-bottom: 22px;
}
.menu-configuration .mc-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
  color: #527099;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
}
.menu-configuration h2 {
  margin: 0 0 8px;
  font-size: clamp(21px, 2vw, 27px);
  font-weight: 700;
  letter-spacing: -0.5px;
  color: var(--mc-ink);
}
.menu-configuration .mc-page-heading p {
  margin: 0;
  color: var(--mc-muted);
  font-size: 13px;
}
.menu-configuration .btn {
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  padding: 9px 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}
.menu-configuration .btn-primary {
  background: #2463eb;
  border-color: #2463eb;
  box-shadow: 0 3px 7px rgba(36, 99, 235, 0.1019607843);
}
.menu-configuration .btn-outline-secondary {
  border-color: #d7dfeb;
  color: #52627b;
  background: #fff;
}
.menu-configuration .btn-outline-secondary:hover {
  background: #f0f4fa;
}
.menu-configuration .btn-outline-danger {
  border-color: #f2d6dc;
  color: #b93c51;
}
.menu-configuration .btn-outline-danger:not(:disabled):hover,
.menu-configuration .btn-outline-danger:not(:disabled):focus-visible,
.menu-configuration .btn-outline-danger:not(:disabled):active {
  color: #fff;
  background-color: #b93c51;
  border-color: #b93c51;
}
.menu-configuration .btn:focus-visible, .menu-configuration .mc-role:focus-visible {
  outline: 3px solid #93baff;
  outline-offset: 2px;
}
.menu-configuration .mc-topbar {
  position: sticky;
  top: 72px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 18px;
  margin-bottom: 20px;
  border: 1px solid var(--mc-line);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(24, 51, 87, 0.031372549);
}
.menu-configuration .mc-save-context {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.menu-configuration .mc-save-context strong {
  display: block;
  font-size: 18px;
}
.menu-configuration .mc-save-context span:not(.mc-state-dot) {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  color: var(--mc-muted);
}
.menu-configuration .mc-state-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8c9cb2;
  flex-shrink: 0;
}
.menu-configuration .mc-state-dot.is-dirty {
  background: #e8a126;
  box-shadow: 0 0 0 4px #fff4df;
}
.menu-configuration .mc-top-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.menu-configuration .mc-primary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}
.menu-configuration .mc-success {
  color: #23794f;
  font-size: 12px;
  max-width: 240px;
}
.menu-configuration .mc-workspace {
  display: grid;
  grid-template-columns: 270px minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}
.menu-configuration .mc-panel {
  background: #fff;
  border: 1px solid var(--mc-line);
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 3px 14px rgba(24, 51, 87, 0.0196078431);
  min-width: 0;
}
.menu-configuration .mc-panel-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.menu-configuration h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--mc-ink);
}
.menu-configuration .mc-panel-heading p {
  color: var(--mc-muted);
  font-size: 12px;
  margin: 6px 0 0;
}
.menu-configuration .mc-count {
  color: #657793;
  background: #f0f4fa;
  border-radius: 6px;
  padding: 3px 6px;
  font-size: 10px;
}
.menu-configuration .mc-selected-count {
  color: #2463b7;
  background: #edf4ff;
  padding: 6px 10px;
  border-radius: 20px;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 600;
}
.menu-configuration .mc-search {
  position: relative;
  margin-bottom: 16px;
}
.menu-configuration .mc-search > .mc-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #8a99ad;
  width: 14px;
  pointer-events: none;
}
.menu-configuration .mc-search .form-control {
  padding: 10px 12px 10px 35px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  font-size: 12px;
}
.menu-configuration .mc-role-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 2px;
}
.menu-configuration .mc-role {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 9px;
  padding: 11px 10px;
  color: #42536c;
  transition: background 0.15s;
}
.menu-configuration .mc-role:hover:not(:disabled) {
  background: #f6f8fc;
}
.menu-configuration .mc-role.active {
  color: #215acb;
  background: #edf3ff;
  border-color: #cddfff;
}
.menu-configuration .mc-role:disabled {
  cursor: default;
}
.menu-configuration .mc-role-text {
  flex: 1 1;
  min-width: 0;
}
.menu-configuration .mc-role strong {
  display: block;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.menu-configuration .mc-role small {
  display: block;
  margin-top: 4px;
  color: #7d8da5;
  font-size: 9px;
  letter-spacing: 0.45px;
  overflow-wrap: anywhere;
}
.menu-configuration .mc-role-icon {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f1f4f9;
  color: #7486a0;
  font-size: 16px;
}
.menu-configuration .mc-role.active .mc-role-icon {
  color: #2463eb;
  background: #dce8ff;
}
.menu-configuration .mc-role > .mc-icon {
  width: 12px;
}
.menu-configuration .mc-role-actions {
  display: flex;
  gap: 7px;
  padding-top: 16px;
  margin-top: 15px;
  border-top: 1px solid var(--mc-line);
}
.menu-configuration .mc-role-actions .btn {
  flex: 1 1;
  padding: 8px 7px;
  font-size: 11px;
}
.menu-configuration .mc-hint {
  display: flex;
  gap: 8px;
  color: var(--mc-muted);
  font-size: 11px;
  line-height: 1.6;
  margin: 0 0 16px;
}
.menu-configuration .mc-menu-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 10px;
  min-width: 0;
}
.menu-configuration .mc-menu-group {
  border: 1px solid var(--mc-line);
  border-radius: 9px;
  overflow: hidden;
}
.menu-configuration .mc-menu-group.mc-has-children {
  grid-column: 1/-1;
}
.menu-configuration .mc-menu-row {
  display: flex;
  align-items: center;
  min-height: 47px;
  gap: 8px;
  padding: 11px 13px;
  background: #fff;
}
.menu-configuration .mc-menu-row:hover {
  background: #f8faff;
}
.menu-configuration .mc-menu-row.is-selected {
  background: #f3f7ff;
}
.menu-configuration .mc-menu-row .form-check {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.menu-configuration .mc-menu-row .form-check-input {
  float: none;
  margin: 0;
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  cursor: pointer;
  border-color: #bccadc;
  border-radius: 4px;
}
.menu-configuration .mc-menu-row .form-check-input:checked {
  background-color: #2463eb;
  border-color: #2463eb;
}
.menu-configuration .mc-menu-row .form-check-label {
  color: #33465f;
  font-size: 12px;
  line-height: 1.5;
  cursor: pointer;
  flex: 1 1;
  overflow-wrap: anywhere;
}
.menu-configuration .mc-has-children > .mc-menu-row .form-check-label {
  font-weight: 600;
}
.menu-configuration .mc-children {
  margin: 0 12px 10px 21px;
  padding: 4px 0 0 10px;
  border-left: 2px solid #e8eef7;
}
.menu-configuration .mc-child + .mc-child {
  border-top: 1px solid #f0f3f8;
}
.menu-configuration .mc-child-count {
  color: #7b8ba2;
  font-size: 10px;
}
.menu-configuration .mc-fixed-badge {
  background: #eaf0fa;
  color: #597094;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 9px;
  white-space: nowrap;
}
.menu-configuration .mc-menu-row .form-check-input:disabled {
  opacity: 0.75;
  cursor: default;
}
.menu-configuration .mc-menu-row .form-check-input:disabled ~ .form-check-label {
  opacity: 1;
  cursor: default;
}
.menu-configuration .mc-empty {
  color: var(--mc-muted);
  padding: 20px 10px;
  text-align: center;
  font-size: 12px;
}
.menu-configuration .mc-dirty-hint {
  margin: 15px 0 0;
  color: #97701d;
  font-size: 11px;
}
@media (max-width: 1100px) {
  .menu-configuration .mc-workspace {
    grid-template-columns: 235px minmax(0, 1fr);
    gap: 14px;
  }
  .menu-configuration .mc-panel {
    padding: 16px;
  }
  .menu-configuration .mc-topbar {
    flex-wrap: wrap;
  }
}
@media (max-width: 767px) {
  .menu-configuration {
    padding: 18px 12px !important;
  }
  .menu-configuration .mc-topbar {
    top: 64px;
    padding: 12px;
    gap: 10px;
  }
  .menu-configuration .mc-top-actions {
    width: 100%;
    justify-content: flex-start;
  }
  .menu-configuration .mc-top-actions .btn {
    font-size: 11px;
    padding: 8px 10px;
  }
  .menu-configuration .mc-top-actions .mc-success {
    max-width: none;
    width: 100%;
  }
  .menu-configuration .mc-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .menu-configuration .mc-role-list {
    max-height: 230px;
  }
  .menu-configuration .mc-menu-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .menu-configuration .mc-panel-heading {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/settings/MenuConfiguration.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6BAAA;AAAF;AADE;EAAW,qBAAA;EAAuB,cAAA;EAAgB,sBAAA;AAMpD;AAHE;EAAmB,mBAAA;AAMrB;AALE;EAAc,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,kBAAA;EAAoB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,qBAAA;EAAuB,yBAAA;AAgB5J;AAfE;EAAK,eAAA;EAAiB,iCAAA;EAAmC,gBAAA;EAAkB,sBAAA;EAAuB,oBAAA;AAsBpG;AArBE;EAAqB,SAAA;EAAW,sBAAA;EAAwB,eAAA;AA0B1D;AAzBE;EAAO,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;EAAmB,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EAAU,mBAAA;AAoCjK;AAnCE;EAAe,mBAAA;EAAqB,qBAAA;EAAuB,qDAAA;AAwC7D;AAvCE;EAAyB,qBAAA;EAAuB,cAAA;EAAgB,gBAAA;AA4ClE;AA3CE;EAA+B,mBAAA;AA8CjC;AA7CE;EAAsB,qBAAA;EAAuB,cAAA;AAiD/C;AAhDE;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AAkDJ;AAhDE;EAA6C,0BAAA;EAA4B,mBAAA;AAoD3E;AAnDE;EAAa,gBAAA;EAAkB,SAAA;EAAW,WAAA;EAAa,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,kBAAA;EAAoB,mBAAA;EAAqB,gCAAA;EAAkC,mBAAA;EAAqB,gBAAA;EAAkB,oDAAA;AAkE1P;AAjEE;EAAmB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,YAAA;AAuEpE;AAtEE;EAA0B,cAAA;EAAgB,eAAA;AA0E5C;AAzEE;EAA2C,cAAA;EAAgB,eAAA;EAAiB,eAAA;EAAiB,sBAAA;AA+E/F;AA9EE;EAAgB,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;AAqFpF;AApFE;EAAyB,mBAAA;EAAqB,6BAAA;AAwFhD;AAvFE;EAAkB,aAAA;EAAe,yBAAA;EAA2B,mBAAA;EAAqB,QAAA;EAAU,eAAA;AA8F7F;AA7FE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,iBAAA;AAmGtE;AAlGE;EAAc,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAuGjD;AAtGE;EAAgB,aAAA;EAAe,2CAAA;EAA6C,SAAA;EAAW,kBAAA;AA4GzF;AA3GE;EAAY,gBAAA;EAAkB,gCAAA;EAAkC,mBAAA;EAAqB,aAAA;EAAe,qDAAA;EAAkC,YAAA;AAmHxI;AAlHE;EAAoB,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EAAW,mBAAA;AAyHrG;AAxHE;EAAK,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,SAAA;EAAW,eAAA;EAAiB,gBAAA;EAAkB,oBAAA;AAiInG;AAhIE;EAAsB,sBAAA;EAAwB,eAAA;EAAiB,eAAA;AAqIjE;AApIE;EAAY,cAAA;EAAgB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,eAAA;AA2IzF;AA1IE;EAAqB,cAAA;EAAgB,mBAAA;EAAqB,iBAAA;EAAmB,mBAAA;EAAqB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;AAmJ1I;AAlJE;EAAa,kBAAA;EAAoB,mBAAA;AAsJnC;AArJE;EAAwB,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,cAAA;EAAgB,WAAA;EAAa,oBAAA;AA8J9H;AA7JE;EAA2B,4BAAA;EAA8B,kBAAA;EAAoB,mBAAA;EAAqB,yBAAA;EAA2B,eAAA;AAoK/H;AAnKE;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,gBAAA;EAAkB,gBAAA;EAAkB,YAAA;AA2KvG;AA1KE;EAAW,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAAa,gBAAA;EAAkB,uBAAA;EAAyB,6BAAA;EAA+B,kBAAA;EAAoB,kBAAA;EAAoB,cAAA;EAAgB,4BAAA;AAuL3M;AAtLE;EAAgC,mBAAA;AAyLlC;AAxLE;EAAkB,cAAA;EAAgB,mBAAA;EAAqB,qBAAA;AA6LzD;AA5LE;EAAoB,eAAA;AA+LtB;AA9LE;EAAgB,SAAA;EAAS,YAAA;AAkM3B;AAjME;EAAkB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;AAuMvE;AAtME;EAAiB,cAAA;EAAgB,eAAA;EAAiB,cAAA;EAAgB,cAAA;EAAgB,sBAAA;EAAuB,uBAAA;AA8M3G;AA7ME;EAAgB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,kBAAA;EAAoB,mBAAA;EAAqB,cAAA;EAAgB,eAAA;AAwN1J;AAvNE;EAAgC,cAAA;EAAgB,mBAAA;AA2NlD;AA1NE;EAAsB,WAAA;AA6NxB;AA5NE;EAAmB,aAAA;EAAe,QAAA;EAAU,iBAAA;EAAmB,gBAAA;EAAkB,oCAAA;AAmOnF;AAlOE;EAAwB,SAAA;EAAS,gBAAA;EAAkB,eAAA;AAuOrD;AAtOE;EAAW,aAAA;EAAe,QAAA;EAAU,sBAAA;EAAwB,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AA8OjG;AA7OE;EAAgB,aAAA;EAAe,gDAAA;EAAkD,kBAAA;EAAoB,SAAA;EAAW,YAAA;AAoPlH;AAnPE;EAAiB,gCAAA;EAAkC,kBAAA;EAAoB,gBAAA;AAwPzE;AAvPE;EAAiC,iBAAA;AA0PnC;AAzPE;EAAe,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,QAAA;EAAU,kBAAA;EAAoB,gBAAA;AAiQrG;AAhQE;EAAqB,mBAAA;AAmQvB;AAlQE;EAA2B,mBAAA;AAqQ7B;AApQE;EAA2B,SAAA;EAAS,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,UAAA;EAAY,SAAA;EAAW,YAAA;AA6Q5G;AA5QE;EAAiC,WAAA;EAAa,SAAA;EAAW,cAAA;EAAgB,WAAA;EAAa,YAAA;EAAc,eAAA;EAAiB,qBAAA;EAAuB,kBAAA;AAsR9I;AArRE;EAAyC,yBAAA;EAA2B,qBAAA;AAyRtE;AAxRE;EAAiC,cAAA;EAAgB,eAAA;EAAiB,gBAAA;EAAkB,eAAA;EAAiB,SAAA;EAAS,uBAAA;AAgShH;AA/RE;EAAoD,gBAAA;AAkStD;AAjSE;EAAe,wBAAA;EAA0B,qBAAA;EAAuB,8BAAA;AAsSlE;AArSE;EAAwB,6BAAA;AAwS1B;AAvSE;EAAkB,cAAA;EAAgB,eAAA;AA2SpC;AA1SE;EAAkB,mBAAA;EAAqB,cAAA;EAAgB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,mBAAA;AAkT/G;AAjTE;EAA0C,aAAA;EAAc,eAAA;AAqT1D;AApTE;EAA8D,UAAA;EAAY,eAAA;AAwT5E;AAvTE;EAAY,sBAAA;EAAwB,kBAAA;EAAoB,kBAAA;EAAoB,eAAA;AA6T9E;AA5TE;EAAiB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AAiUrD;AA/TE;EACE;IAAgB,2CAAA;IAA6C,SAAA;EAmU/D;EAlUE;IAAY,aAAA;EAqUd;EApUE;IAAa,eAAA;EAuUf;AACF;AAtUE;EAnFF;IAoFI,6BAAA;EAyUF;EAxUE;IAAa,SAAA;IAAW,aAAA;IAAe,SAAA;EA6UzC;EA5UE;IAAkB,WAAA;IAAa,2BAAA;EAgVjC;EA/UE;IAAuB,eAAA;IAAiB,iBAAA;EAmV1C;EAlVE;IAA8B,eAAA;IAAiB,WAAA;EAsVjD;EArVE;IAAgB,qCAAA;EAwVlB;EAvVE;IAAgB,iBAAA;EA0VlB;EAzVE;IAAgB,qCAAA;EA4VlB;EA3VE;IAAoB,eAAA;EA8VtB;AACF","sourcesContent":[".menu-configuration {\n  --mc-ink: #172b4d;\n  --mc-muted: #64748b;\n  --mc-line: #e4eaf2;\n  color: var(--mc-ink);\n  .mc-icon { display: inline-block; flex: 0 0 auto; vertical-align: middle; }\n  padding: 26px 24px !important;\n\n  .mc-page-heading { margin-bottom: 22px; }\n  .mc-eyebrow { display: flex; align-items: center; gap: 7px; margin-bottom: 8px; color: #527099; font-size: 11px; font-weight: 700; letter-spacing: 1.4px; text-transform: uppercase; }\n  h2 { margin: 0 0 8px; font-size: clamp(21px, 2vw, 27px); font-weight: 700; letter-spacing: -.5px; color: var(--mc-ink); }\n  .mc-page-heading p { margin: 0; color: var(--mc-muted); font-size: 13px; }\n  .btn { border-radius: 8px; font-size: 12px; font-weight: 600; padding: 9px 13px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; }\n  .btn-primary { background: #2463eb; border-color: #2463eb; box-shadow: 0 3px 7px #2463eb1a; }\n  .btn-outline-secondary { border-color: #d7dfeb; color: #52627b; background: #fff; }\n  .btn-outline-secondary:hover { background: #f0f4fa; }\n  .btn-outline-danger { border-color: #f2d6dc; color: #b93c51; }\n  .btn-outline-danger:not(:disabled):hover,\n  .btn-outline-danger:not(:disabled):focus-visible,\n  .btn-outline-danger:not(:disabled):active {\n    color: #fff;\n    background-color: #b93c51;\n    border-color: #b93c51;\n  }\n  .btn:focus-visible, .mc-role:focus-visible { outline: 3px solid #93baff; outline-offset: 2px; }\n  .mc-topbar { position: sticky; top: 72px; z-index: 20; display: flex; align-items: center; justify-content: space-between; gap: 14px; padding: 14px 18px; margin-bottom: 20px; border: 1px solid var(--mc-line); border-radius: 12px; background: #fff; box-shadow: 0 4px 16px #18335708; }\n  .mc-save-context { display: flex; align-items: center; gap: 10px; min-width: 0; }\n  .mc-save-context strong { display: block; font-size: 18px; }\n  .mc-save-context span:not(.mc-state-dot) { display: block; margin-top: 3px; font-size: 11px; color: var(--mc-muted); }\n  .mc-state-dot { width: 8px; height: 8px; border-radius: 50%; background: #8c9cb2; flex-shrink: 0; }\n  .mc-state-dot.is-dirty { background: #e8a126; box-shadow: 0 0 0 4px #fff4df; }\n  .mc-top-actions { display: flex; justify-content: flex-end; align-items: center; gap: 8px; flex-wrap: wrap; }\n  .mc-primary-actions { display: flex; align-items: center; gap: 8px; flex-wrap: nowrap; }\n  .mc-success { color: #23794f; font-size: 12px; max-width: 240px; }\n  .mc-workspace { display: grid; grid-template-columns: 270px minmax(0, 1fr); gap: 20px; align-items: start; }\n  .mc-panel { background: #fff; border: 1px solid var(--mc-line); border-radius: 14px; padding: 20px; box-shadow: 0 3px 14px #18335705; min-width: 0; }\n  .mc-panel-heading { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 18px; }\n  h3 { display: flex; align-items: center; gap: 8px; margin: 0; font-size: 15px; font-weight: 700; color: var(--mc-ink); }\n  .mc-panel-heading p { color: var(--mc-muted); font-size: 12px; margin: 6px 0 0; }\n  .mc-count { color: #657793; background: #f0f4fa; border-radius: 6px; padding: 3px 6px; font-size: 10px; }\n  .mc-selected-count { color: #2463b7; background: #edf4ff; padding: 6px 10px; border-radius: 20px; white-space: nowrap; font-size: 11px; font-weight: 600; }\n  .mc-search { position: relative; margin-bottom: 16px; }\n  .mc-search > .mc-icon { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); color: #8a99ad; width: 14px; pointer-events: none; }\n  .mc-search .form-control { padding: 10px 12px 10px 35px; border-radius: 8px; background: #f8fafc; border: 1px solid #e7edf5; font-size: 12px; }\n  .mc-role-list { display: flex; flex-direction: column; gap: 5px; max-height: 60vh; overflow-y: auto; padding: 2px; }\n  .mc-role { display: flex; align-items: center; gap: 10px; width: 100%; text-align: left; background: transparent; border: 1px solid transparent; border-radius: 9px; padding: 11px 10px; color: #42536c; transition: background .15s; }\n  .mc-role:hover:not(:disabled) { background: #f6f8fc; }\n  .mc-role.active { color: #215acb; background: #edf3ff; border-color: #cddfff; }\n  .mc-role:disabled { cursor: default; }\n  .mc-role-text { flex: 1; min-width: 0; }\n  .mc-role strong { display: block; font-size: 12px; font-weight: 600; overflow-wrap: anywhere; }\n  .mc-role small { display: block; margin-top: 4px; color: #7d8da5; font-size: 9px; letter-spacing: .45px; overflow-wrap: anywhere; }\n  .mc-role-icon { display: grid; place-items: center; width: 32px; height: 32px; flex-shrink: 0; border-radius: 8px; background: #f1f4f9; color: #7486a0; font-size: 16px; }\n  .mc-role.active .mc-role-icon { color: #2463eb; background: #dce8ff; }\n  .mc-role > .mc-icon { width: 12px; }\n  .mc-role-actions { display: flex; gap: 7px; padding-top: 16px; margin-top: 15px; border-top: 1px solid var(--mc-line); }\n  .mc-role-actions .btn { flex: 1; padding: 8px 7px; font-size: 11px; }\n  .mc-hint { display: flex; gap: 8px; color: var(--mc-muted); font-size: 11px; line-height: 1.6; margin: 0 0 16px; }\n  .mc-menu-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); align-items: start; gap: 10px; min-width: 0; }\n  .mc-menu-group { border: 1px solid var(--mc-line); border-radius: 9px; overflow: hidden; }\n  .mc-menu-group.mc-has-children { grid-column: 1 / -1; }\n  .mc-menu-row { display: flex; align-items: center; min-height: 47px; gap: 8px; padding: 11px 13px; background: #fff; }\n  .mc-menu-row:hover { background: #f8faff; }\n  .mc-menu-row.is-selected { background: #f3f7ff; }\n  .mc-menu-row .form-check { flex: 1; display: flex; align-items: center; gap: 10px; padding: 0; margin: 0; min-width: 0; }\n  .mc-menu-row .form-check-input { float: none; margin: 0; flex-shrink: 0; width: 17px; height: 17px; cursor: pointer; border-color: #bccadc; border-radius: 4px; }\n  .mc-menu-row .form-check-input:checked { background-color: #2463eb; border-color: #2463eb; }\n  .mc-menu-row .form-check-label { color: #33465f; font-size: 12px; line-height: 1.5; cursor: pointer; flex: 1; overflow-wrap: anywhere; }\n  .mc-has-children > .mc-menu-row .form-check-label { font-weight: 600; }\n  .mc-children { margin: 0 12px 10px 21px; padding: 4px 0 0 10px; border-left: 2px solid #e8eef7; }\n  .mc-child + .mc-child { border-top: 1px solid #f0f3f8; }\n  .mc-child-count { color: #7b8ba2; font-size: 10px; }\n  .mc-fixed-badge { background: #eaf0fa; color: #597094; border-radius: 4px; padding: 3px 6px; font-size: 9px; white-space: nowrap; }\n  .mc-menu-row .form-check-input:disabled { opacity: .75; cursor: default; }\n  .mc-menu-row .form-check-input:disabled ~ .form-check-label { opacity: 1; cursor: default; }\n  .mc-empty { color: var(--mc-muted); padding: 20px 10px; text-align: center; font-size: 12px; }\n  .mc-dirty-hint { margin: 15px 0 0; color: #97701d; font-size: 11px; }\n\n  @media (max-width: 1100px) {\n    .mc-workspace { grid-template-columns: 235px minmax(0, 1fr); gap: 14px; }\n    .mc-panel { padding: 16px; }\n    .mc-topbar { flex-wrap: wrap; }\n  }\n  @media (max-width: 767px) {\n    padding: 18px 12px !important;\n    .mc-topbar { top: 64px; padding: 12px; gap: 10px; }\n    .mc-top-actions { width: 100%; justify-content: flex-start; }\n    .mc-top-actions .btn { font-size: 11px; padding: 8px 10px; }\n    .mc-top-actions .mc-success { max-width: none; width: 100%; }\n    .mc-workspace { grid-template-columns: minmax(0, 1fr); }\n    .mc-role-list { max-height: 230px; }\n    .mc-menu-grid { grid-template-columns: minmax(0, 1fr); }\n    .mc-panel-heading { flex-wrap: wrap; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
